import { styled } from '@/styled-system/jsx';
import type { ElementType } from 'react';

export const StyledCenter = styled('div', {
  base: {
    textAlign: 'center',
    m: 'auto',
  },
}) as <T extends ElementType = 'div'>(props: { as?: T } & React.ComponentPropsWithoutRef<T>) => JSX.Element;
